<template>
    <div
        class="row latest-modules-wrapper"
        v-if="modulesIn.length">
        <div
            class="col-12 col-sm-6 col-lg-6 col-xl-4 module"
            v-for="module in modulesIn"
            :key="module.id">
            <design-2021-module-card-component
                :module-in="module"
                @click.native="showModuleDetailModal(module)">
                <template #header>
                    <div class="actions">
                        <div class="module-show">
                            <b-button
                                class="btn-show btn-show-module remove-icon-margin"
                                v-b-tooltip="$t('modules.view_module')"
                                variant="primary-icon"
                                @click.prevent.stop="showModuleDetailModal(module)">
                            </b-button>
                        </div>
                    </div>
                </template>
            </design-2021-module-card-component>

            <design-2021-module-show-details-modal-component
                :module-in="module"></design-2021-module-show-details-modal-component>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-module-latest-registered-module-component',
    props: {
        modulesIn: [Array, Object],
    },
    data() {
        return {};
    },

    methods: {
        showModuleDetailModal(module) {
            const id = 'module-show-module-detail-' + module.id;
            this.$bvModal.show(id);
        },

        showModuleUnregisterModal(module) {
            if (module.userHasMultipleRegistrations(this.$authUser.id)) {
                this.$refs['module-show-unregister'].show(module.id);
            } else {
                this.alert
                    .confirm(
                        this.$t('modules.unregister_module'),
                        this.$t('modules.are_you_sure_you_want_to_unregister_for_this_module'),
                        this.$t('modules.yes_unregister'),
                    )
                    .then((confirm) => {
                        if (!confirm) {
                            return;
                        }

                        let moduleUser = module.findModuleUserByUserId(this.$authUser.id);
                        this.alert.saving();
                        this.axios.delete(this.routes.deleteModuleUser(moduleUser.id)).then(
                            (response) => {
                                moduleUser.remove();
                                this.alert.success();
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                    });
            }
        },
    },
};
</script>

<style scoped></style>
